/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
//enabling lazy load for images
require('./lazy-images');
//enabling brochure slider swipe
require('./brochure-swipe');

$(".menuButton").click(function () {
  $("body").toggleClass('overflowLock');
});

setTimeout(function () {
  let ref = document.referrer;
  let siteurl = window.location.protocol + '//' + window.location.hostname + '/';
  if (ref.indexOf(siteurl) !== -1) {
  }
  else {
    (function (window, location) {
      history.replaceState(null, document.title, location.pathname + "#!/auth");
      history.pushState(null, document.title, location.pathname);

      window.addEventListener("popstate", function () {
        if (location.hash === "#!/auth") {
          history.replaceState(null, document.title, location.pathname);
          setTimeout(function () {
            location.replace(siteurl);
          }, 100);
        }
      }, false);
    }(window, location));
  }
}, 2000);

// shops search used in components/shops/list.blade
$(document).ready(function(){
    $("#shopsSearchInput").on("keyup", function() {
        var value = $(this).val().toLowerCase();

        $(".shopContainer").each(function(index, container) {
            var isCityVisibleInThisContainer = false;

            $(container).find(".shopRows").children().each(function() {
                var shopTitle = $(this).data('shop-title');
                if(shopTitle && shopTitle.toLowerCase().indexOf(value) > -1) {
                    $(this).show();
                    isCityVisibleInThisContainer = true;
                } else {
                    $(this).hide();
                }
            });

            if(isCityVisibleInThisContainer) {
                $(container).show();
            } else {
                $(container).hide();
            }
        });
    });
});

// cities search used in web/city/index-cities.blade
$(document).ready(function(){
    $("#citiesSearchInput").on("keyup", function() {
        var value = $(this).val().toLowerCase();

        $(".cityContainer").each(function(index, container) {
            var isCityVisibleInThisContainer = false;

            $(container).find(".cityRows").children().each(function() {
                var cityTitle = $(this).data('city-title');
                if(cityTitle && cityTitle.toLowerCase().indexOf(value) > -1) {
                    $(this).show();
                    isCityVisibleInThisContainer = true;
                } else {
                    $(this).hide();
                }
            });

            if(isCityVisibleInThisContainer) {
                $(container).show();
            } else {
                $(container).hide();
            }
        });
    });
});

//city shops search used in web/city/index-city-shops.blade
$(document).ready(function(){
    $("#cityShopsSearchInput").on("keyup", function() {
        var value = $(this).val().toLowerCase();

        $(".cityShopContainer").each(function(index, container) {
            var isCityVisibleInThisContainer = false;

            $(container).find(".cityShopRows").children().each(function() {
                var shopTitle = $(this).data('shop-title');
                if(shopTitle && shopTitle.toLowerCase().indexOf(value) > -1) {
                    $(this).show();
                    isCityVisibleInThisContainer = true;
                } else {
                    $(this).hide();
                }
            });

            if(isCityVisibleInThisContainer) {
                $(container).show();
            } else {
                $(container).hide();
            }
        });
    });
});

$(document).ready(function() {
    const $showMoreButton = $('#show-more-button');
    const $showLessButton = $('#show-less-button');
    const $addressDivs = $('.address-div');

    $showMoreButton.on('click', function() {
        $addressDivs.each(function(index) {
            if (index >= 9) {
                $(this).show();
            }
        });
        $showMoreButton.hide();
        $showLessButton.show();
    });

    $showLessButton.on('click', function() {
        $addressDivs.each(function(index) {
            if (index >= 9) {
                $(this).hide();
            }
        });
        $showMoreButton.show();
        $showLessButton.hide();
    });
});
